import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import { NavBullet } from "./Navigation";
import styled, { css } from "styled-components";
import brainImage from "../../assets/brain.png";
import { useHistory } from "react-router-dom";
import { setNavItem } from "../../features/navigation/navigationSlice";
import { navigationHistory } from "../../routes";

const BrainContainer = styled.div`
  display: flex;
  background-image: url(${brainImage});
  min-height: 450px;
  background-size: 260px;
  background-repeat: no-repeat;
  background-position: 100% bottom;
  padding: 0 40px;
  position: relative;
  min-width: 240px;
`;

const BrainBullet = styled(NavBullet)`
  border: 1px solid #fff;
  width: 24px;
  pointer-events: all;
  height: 24px;

  ${(p: any) =>
    p.isActive &&
    css`
      box-shadow: 0 0 10px 8px ${(prop: any) => prop.color}40;
    `}

  :hover {
    cursor: pointer;
    box-shadow: 0 0 10px 8px ${(prop: any) => prop.color}40;
  }
`;

const BulletAligner: any = styled.div`
  position: absolute;
  bottom: 80px;
  pointer-events: none;
  left: 70px;
  width: 200px;
  height: 200px;

  transform: ${(p: any) => css`rotate(${20 * p.item - 50}deg)`};
  ${BrainBullet} {
    transform: ${(p: any) => css`rotate(${-20 * p.item + 50}deg)`};
  }
`;

export default () => {
  const navigation = useSelector((state: RootState) => state.navigation);
  const dispatch = useDispatch();

  return (
    <div>
      <BrainContainer>
        {navigation.items.map((navItem, index) => {
          const isActive =
            navigation.hoverItem && navigation.hoverItem.name === navItem.name;
          return (
            <BulletAligner item={index}>
              <BrainBullet
                onMouseEnter={() => dispatch(setNavItem(navItem))}
                onClick={() => navigationHistory.push("/games/" + navItem.name)}
                isActive={isActive ? "1" : ""}
                key={navItem.name}
                color={navItem.color}
              >
                {index + 1}
              </BrainBullet>
            </BulletAligner>
          );
        })}
      </BrainContainer>
    </div>
  );
};
